import { ArticleClass } from "./article-class";

export class DataClass {
    articleMask: string;
    articles: ArticleClass[] = [];
    isAutoSelected: boolean = false;
}